// src/components/auth/AccessDenied.tsx
//
// The content a route guard shows when the reader's role does not open the
// page. It is drawn in the page's content frame (see ProtectedRoute's
// `frame`), so the section menu stays and the reader can simply pick another
// page.

import { Button, Center, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import { useNavigate } from "@/routing/accountRouting";

type Props = {
  /** Who the page IS for, as one sentence. */
  audience: string;
};

export default function AccessDenied({ audience }: Props) {
  const navigate = useNavigate();
  return (
    <Center h="100%" mih={320} p="xl">
      <Stack align="center" gap="sm" maw={420} ta="center">
        <ThemeIcon size={48} radius="xl" variant="light" color="gray">
          <IconLock size={24} />
        </ThemeIcon>
        <Title order={3}>You don't have access to this page</Title>
        <Text c="dimmed" size="sm">
          {audience}
        </Text>
        <Button variant="light" mt="xs" onClick={() => navigate("/")}>
          Go to home
        </Button>
      </Stack>
    </Center>
  );
}
